import { CustomError } from '@core/utils';

const ANOTHER_ENTRY_IN_PROGRESS = 10001;

//* 서버가 사유를 담아 거절한 응답만 처리 완료로 본다 — 5xx·네트워크 실패·다른 요청 처리 중(10001)은 같은 키로 재전송해야 포인트가 두 번 빠지지 않는다.
export const isRejectedByServer = (error: unknown): error is CustomError =>
  error instanceof CustomError &&
  error.status < 500 &&
  error.return_message !== '' &&
  error.return_code !== ANOTHER_ENTRY_IN_PROGRESS;
